import React, { useEffect } from "react";

import Form from "../../../features/auth/register/Form";
const Signup = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <Form />;
};

export default Signup;
